import $ from "jquery";
import moment from "moment";
import "./header.scss";

// TODO refactor notifications out, probably into a directive
window.app.directive("msApplicationHeader", [
  function() {
    return {
      restrict: "A",
      scope: false,
      controller: [
        "$scope",
        "$rootScope",
        "apiHelper2",
        "toastr",
        "getAvatarSVG",
        function($scope, $rootScope, simpleApi, toastr, getAvatarSVG) {
          const notificationsApi = getNotificationsApi(simpleApi);
          const createTimeComp = (a, b) =>
            b.createTimestamp - a.createTimestamp;
          $rootScope.fetchNotifications = (refresh = false) => {
            if ($rootScope.publicMode) return;
            notificationsApi.list({}, { bypassCache: refresh }).then(notifs => {
              $rootScope.notifications = notifs.slice().sort(createTimeComp);
            });
          };
          $rootScope.fetchNotifications();

          $rootScope.togglePopup = function(name, show) {
            const $popup = $(".popup-container." + name + "-container");
            const $icon = $(".header-items ." + name + "-icon");
            const open = $popup.css("opacity") == 1;

            const l =
              $icon.width() / 2 + $icon.offset().left - $popup.offset().left;

            const openStyle = {
              transform: "scale(1)",
              opacity: 1,
              pointerEvents: "auto"
            };

            var $arrow = $popup.find(".popup-arrow");
            if (!$arrow[0]) {
              $popup.append("<div class='popup-arrow'></div>");
              $arrow = $popup.find(".popup-arrow");
              $arrow.css(
                "left",
                $icon.width() / 2 -
                  10 +
                  $icon.offset().left -
                  $popup.offset().left
              );
              $popup[0].closedStyle = {
                transform: `scale(0.5) translateX(0px)`,
                opacity: 0,
                pointerEvents: "none",
                transformOrigin: l + "px -10px"
              };
              $popup.css($popup[0].closedStyle);
              setTimeout(() => {
                $popup.css({
                  transition: "0.3s all cubic-bezier(0.68, -0.55, 0.265, 1.55)"
                });
              }, 0);

              $popup.addClass("inited");
            }

            setTimeout(() => {
              const showNow = (show === undefined && !open) || show;
              $popup.css(showNow ? openStyle : $popup[0].closedStyle);

              $(".popup-container.inited:not(." + name + "-container)").each(
                (i, e) => {
                  $(e).css(e.closedStyle);
                }
              );
            }, 0);
            // const $popup = $(".popup-container." + name + "-container");
            // const $icon = $(".header-items ." + name + "-icon");
            // const open = $popup.hasClass("open");
            // const willOpen = !open && show !== false;
            //
            // var mustInit = false;
            // if (willOpen) {
            //   var $arrow = $popup.find(".popup-arrow");
            //   mustInit = !$arrow[0];
            //   if (!$arrow[0]) {
            //     $popup.append("<div class='popup-arrow'></div>");
            //     $arrow = $popup.find(".popup-arrow");
            //     $popup.addClass("_measure");
            //     $popup.css("visibility", "hidden");
            //     $arrow.css(
            //       "left",
            //       $icon.width() / 2 -
            //         10 +
            //         $icon.offset().left -
            //         $popup.offset().left
            //     );
            //
            //     $popup.removeClass("_measure");
            //     $popup.css("visibility", "");
            //   }
            // }
            //
            // setTimeout(() => {
            //   $popup.toggleClass(
            //     "open",
            //     show !== undefined ? !!show : undefined
            //   );
            //   $(".popup-container:not(." + name + "-container)").removeClass(
            //     "open"
            //   );
            // }, mustInit ? 300 : 0);
          };

          $rootScope.hideAllPopups = function() {
            // $(".popup-container").removeClass("open");
            $(".popup-container.inited").each((i, e) => {
              $(e).css(e.closedStyle);
            });
          };

          $rootScope.toggleNotifications = function(show) {
            $rootScope.showNotifications =
              show !== undefined ? show : !$rootScope.showNotifications;
            $rootScope.selectedNotif = null;
          };

          $rootScope.showPositionSwitcher = false;
          $rootScope.togglePositionSwitcher = state => {
            if (state !== undefined) {
              return ($rootScope.showPositionSwitcher = state);
            }
            $rootScope.showPositionSwitcher = !$rootScope.showPositionSwitcher;
          };

          $rootScope.positions = $rootScope.userdata.employeeRecords || [];
          $rootScope.activePositionRecordCode =
            $rootScope.activePosition && $rootScope.activePosition.recordCode;

          $rootScope.switchPosition = position => {
            $rootScope.activePosition = position;
            $rootScope.activePositionRecordCode = position.recordCode;
            $rootScope.$emit("position-switch");
          };

          $rootScope.markAsReadAndRefresh = function(id) {
            notificationsApi.markAsRead({ id }).then(() => {
              $rootScope.fetchNotifications(true);
            });
          };

          $rootScope.selectNotif = function(notif) {
            if ($rootScope.selectedNotif === notif.id) {
              $rootScope.selectedNotif = null;
              return;
            }
            $rootScope.selectedNotif = notif.id;

            notificationsApi.markAsRead(notif).then(
              () => {
                notif.hasBeenRead = true;
              },
              error => {
                toastr.error(
                  "An error occurred. Please retry later or contact support."
                );
                console.error(error);
              }
            );
          };

          $rootScope.markNotifAsUnread = function(notif) {
            // alert('ok');
            setTimeout(() => {
              notificationsApi.markAsUnread(notif).then(
                () => {
                  notif.hasBeenRead = false;
                },
                error => {
                  toastr.error(
                    "An error occurred. Please retry later or contact support."
                  );
                  console.error(error);
                }
              );
            }, 50);
          };

          $rootScope.markAllNotifsAsRead = function() {
            // TODO maybe add a new endpoint - this is inefficient
            Promise.all(
              $rootScope.notifications.map(notif =>
                notificationsApi.markAsRead(notif)
              )
            ).then(
              () => {
                $rootScope.fetchNotifications();
              },
              error => {
                toastr.error(
                  "An error occurred. Please retry later or contact support."
                );
                console.error(error);
              }
            );
          };

          $rootScope.gotoNotifURL = function(notif) {
            if (!notif.url) return;
            if (notif.url[0] === "#" || notif.url[0] === "/") {
              window.location.href = notif.url;
            } else {
              window.open(notif.url);
            }
            $rootScope.togglePopup("notifications", false);
          };

          $rootScope.timeDiff = function(ts) {
            return moment(ts).fromNow();
          };

          $rootScope.unreadNotifCount = function() {
            return (
              $rootScope.notifications &&
              $rootScope.notifications.filter(notif => !notif.hasBeenRead)
                .length
            );
          };

          $rootScope.outClick = function(evt) {
            if (!$(evt.target).is(".header-items .popup-icon *")) {
              $rootScope.hideAllPopups();
            }
          };

          $rootScope.getAvatar = () => {
            const { userdata } = $rootScope;
            return (
              userdata.profileImageUrl ||
              getAvatarSVG(userdata.firstName + " " + userdata.lastName)
            );
          };

          $rootScope.visitHome = () => {
            window.location.hash = "/";
          };

          $rootScope.atHome = () => window.location.hash === "#/";

          window.RS = $rootScope;

          // $rootScope.showNotifications
        }
      ],
      // controller: ['$state', '$scope', function ($state, $scope) {
      //   const getCurrentState = () => {
      //     // todo: changing state
      //     return $state.$next || $state.$current;
      //   };
      //   const defaultAction = () => getCurrentState().parent.abstract ? 'menu' : 'arrow_back';
      //   this.getAction = () => {
      //     const currentState = getCurrentState();
      //     if (currentState.headerAction) {
      //       return currentState.headerAction($scope, $state, defaultAction);
      //     }
      //     return defaultAction();
      //   };
      //   this.doAction = $event => {
      //     const action = this.getAction();
      //     const currentState = getCurrentState();
      //     if (currentState.headerActionHandler) {
      //       if (currentState.headerActionHandler($scope, action)) {
      //         return;
      //       }
      //     }
      //     if (action === 'menu') {
      //       return $scope.appMenu.toggle($event);
      //     } else if (action === 'arrow_back') {
      //       return $scope.go('^');
      //     }
      //     throw Error('unkown action ' + action);
      //   };
      // }],
      // controllerAs: 'Header',
      template: (tElement, tAttrs) => {
        tElement.html(require("./header.html"));
      }
    };
  }
]);

function getNotificationsApi(simpleApi) {
  const api = simpleApi({
    name: "notifications",
    key: ":id",
    baseEndpoint: "notifications/$/@/",
    defaultMethods: "L",
    customMethods: {
      markAsUnread: {
        endpoint: "notifications/$/@/unread/:id",
        update: true,
        onUpdate: (r, s) => {
          s.hasBeenRead = false;
          return s;
        }
      },
      markAsRead: {
        endpoint: "notifications/$/@/read/:id",
        update: true,
        onUpdate: (r, s) => {
          s.hasBeenRead = true;
          return s;
        }
      }
      // createTestNotif: { endpoint: 'notifications/createTest/$/@' },
    },
    mockData: [
      {
        id: 1,
        createTimestamp: Date.now() - 86400000,
        title: "Your Article was approved",
        details: 'Your article titled "Such as such" was approved by John Doe',
        hasBeenRead: false,
        url: "http://www.google.com"
      },
      {
        id: 2,
        createTimestamp: Date.now() - 86400000 * 2,
        title:
          "Your Leave Request was rejected and title is a bit longer still",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false,
        url: "http://www.google.com"
      },
      {
        id: 3,
        createTimestamp: Date.now() - 86400000 * 8,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      },
      {
        id: 4,
        createTimestamp: Date.now() - 86400000 * 31,
        title: "One older still",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false,
        url: "http://www.google.com"
      },
      {
        id: 5,
        createTimestamp: Date.now() - 86400000 * 60,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      },
      {
        id: 6,
        createTimestamp: Date.now() - 86400000 * 65,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      },
      {
        id: 7,
        createTimestamp: Date.now() - 86400000 * 80,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      },
      {
        id: 8,
        createTimestamp: Date.now() - 86400000 * 80,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      },
      {
        id: 9,
        createTimestamp: Date.now() - 86400000 * 80,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      },
      {
        id: 10,
        createTimestamp: Date.now() - 86400000 * 80,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      },
      {
        id: 11,
        createTimestamp: Date.now() - 86400000 * 80,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      },
      {
        id: 12,
        createTimestamp: Date.now() - 86400000 * 80,
        title: "Some older notification",
        details:
          'Your request for vacation was rejected by John Doe with message: "We need you!"',
        hasBeenRead: false
      }
    ]
    // mock: true
  });

  return api;
}



// WEBPACK FOOTER //
// ./src/apps/shared/header/index.js